import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  headerTitle: {
    maxWidth: 400,
    margin: 'auto 2rem',
    marginBottom: 35,
  },
  headerTagLine: {
    maxWidth: 400,
    margin: 'auto 2rem',
    marginBottom: 35,
    fontSize: '0.9rem',
  },
  menuBar: {
    marginBottom: 30,
  },
  heightField: {
    height: '3rem',
    marginBottom: 35,
    marginLeft: '6%',
    '& input': {
      height: '0.6rem',
      width: '40%',
    },
    '& label': {
      top: '-2px',
      fontSize: '0.9rem',
    },
  },
  widthField: {
    height: '3rem',
    marginBottom: 35,
    marginRight: '6%',
    '& input': {
      height: '0.6rem',
      width: '40%',
    },
    '& label': {
      fontSize: '0.9rem',
      top: '-2px',
    },
  },
  fontSize: {
    marginLeft: '14px',
    fontSize: '0.7rem',
  },
  infoBackground: {
    background: '#F5F5F5',
    marginTop: 30,
    marginBottom: 40,
  },
  imageBox: {
    height: '2.8rem',
    width: '99%',
    'background-color': '#f5f5f5',
    border: '1px solid #dfdfdf',
  },
  marginLeft: {
    marginLeft: '10px',
    height: '2.8rem',
    width: '99%',
    'background-color': '#f5f5f5',
    border: '1px solid #dfdfdf',
  },
  marginRight: {
    marginRight: '10px',
    height: '2.8rem',
    width: '99%',
    'background-color': '#f5f5f5',
    border: '1px solid #dfdfdf',
  },
  imageQRSize: {
    display: 'block',
    margin: '5px auto',
    width: '2rem',
  },
  imageSize: {
    display: 'block',
    margin: '5px auto',
    width: '5rem',
    height: '65%',
  },
  textSize: {
    fontSize: '0.8rem',
    textAlign: 'center',
    padding: '11px 0',
  },
  textField: {
    marginBottom: 35,
    width: '100%',
  },
}))

export default useStyles
